import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';
import { RoverBrand } from '@rover/types/src/RoverBrand';

const TITLE_SUFFIX = {
  [RoverBrand.Rover]: 'Rover.com',
  [RoverBrand.CatInAFlat]: 'Cat in a Flat',
  [RoverBrand.MadPaws]: 'Mad Paws',
};

export default (): string =>
  getBrandSpecificValue({
    rover: TITLE_SUFFIX[RoverBrand.Rover],
    catInAFlat: TITLE_SUFFIX[RoverBrand.CatInAFlat],
  });
